import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./index.scss";
import { useTranslation } from "../../../hooks/useTranslation";

const CorporateStats = () => {
  const { t } = useTranslation();

  const stats = [
    { number: t('stats1Number'), label: t('stats1Label') },
    { number: t('stats2Number'), label: t('stats2Label') },
    { number: t('stats3Number'), label: t('stats3Label') },
  ];

  return (
    <section className="corporate-stats py-5">
      <Container>
        <Row className="align-items-center">
          <Col md={5} className="title-col">
            <h2>
              {t('corporateStatsTitle')}
              <br />
              {t('corporateStatsSubtitle')}
            </h2>
          </Col>
          <Col md={7}>
            <Row>
              {stats.map((stat, idx) => (
                <Col key={idx} xs={4} className="stat-item ">
                  <h3>{stat.number}</h3>
                  <p>{stat.label}</p>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CorporateStats;
